import { ReactElement } from 'react';
import { SwiperImages } from '~/ui/assets/mocks/swiperImages';
import { Swiper as ReactSwiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import useSwiperRef from './useSwiperRef';
import { EffectCoverflow, Mousewheel, Pagination, Navigation } from 'swiper/modules';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface SwiperProps {
  slides: SwiperImages[];
}

const Swiper = ({ slides }: SwiperProps): ReactElement => {
  const [nextEl, nextElRef] = useSwiperRef();
  const [prevEl, prevElRef] = useSwiperRef();
  return (
    <ReactSwiper
      modules={[EffectCoverflow, Mousewheel, Pagination, Navigation]}
      navigation={{
        prevEl,
        nextEl,
      }}
      grabCursor
      slidesPerView={1.45}
      centeredSlides
      spaceBetween={75}
      loop
      effect="coverflow"
      coverflowEffect={{
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 1,
        slideShadows: false,
      }}
      breakpoints={{
        // when window width is >= 480px

        660: {
          spaceBetween: 120,
          slidesPerView: 1.45,
        },
        960: {
          spaceBetween: 155,
          slidesPerView: 1.8,
        },
        1440: {
          spaceBetween: 200,
          slidesPerView: 2.1,
        },
      }}
    >
      {slides.map(slide => (
        <SwiperSlide key={slide.id}>
          <Link href={slide.url_key}>
            <img src={slide.img} alt={slide.alt} loading="lazy" />
            <h2>{slide.title}</h2>
          </Link>
        </SwiperSlide>
      ))}
      <div className="swiper-buttons">
        <button
          type="button"
          className="swiper-button swiper-button-prev"
          aria-label="Previous button"
          ref={prevElRef}
        >
          <i className="icon-right-arrow" />
        </button>
        <button
          type="button"
          className="swiper-button swiper-button-next"
          aria-label="Next button"
          ref={nextElRef}
        >
          <i className="icon-right-arrow" />
        </button>
      </div>
    </ReactSwiper>
  );
};

export default Swiper;
